import cn from "classnames";

import { convertValueToLocale } from "helpers/convertValueToLocale";

import { Typography } from "shared/ui/components/Typography";

import { DetailedTable } from "../DetailedTable";

import styles from "./PriceCard.module.scss";

const _cellRenderer = ({
  className,
  item,
  key,
  justifyContent,
  cellType,
  minWidth,
  maxWidth,
}) => {
  switch (key) {
    case "label": {
      const rowKey = item?.key;

      return (
        <div
          className={cn(styles.cell, className)}
          key={key}
          style={{ minWidth, maxWidth, justifyContent: justifyContent }}
        >
          <Typography
            className={cn(styles.labelText, {
              [styles.sumText]: rowKey === "sum",
            })}
            variant="numbers"
          >
            {item[key]}
          </Typography>
        </div>
      );
    }
    default: {
      const value =
        cellType !== "boolean" ? item[key] || "" : item[key] || false;

      const rowKey = item?.key;

      return (
        <div
          className={cn(styles.cell, className)}
          key={key}
          style={{
            minWidth,
            maxWidth,
            justifyContent: justifyContent,
            padding: "8px 12px",
          }}
        >
          <Typography
            className={cn(styles.text, { [styles.sumText]: rowKey === "sum" })}
            variant="numbers"
          >
            {convertValueToLocale(value?.percentage, 2, "%", null)}
          </Typography>

          <Typography
            className={cn(styles.text, { [styles.sumText]: rowKey === "sum" })}
            variant="numbers"
          >
            {convertValueToLocale(value?.price || "", null, "€", null)}
          </Typography>
        </div>
      );
    }
  }
};

const PriceCard = ({ items, columns }: any) => {
  return (
    <DetailedTable
      title="Kaufpreise und Kaufpreisaufteilung"
      data={items}
      columns={columns}
      cellRenderer={(props) => _cellRenderer(props)}
    />
  );
};

export default PriceCard;
